import React from 'react'
import PropTypes from 'prop-types'

class Button extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    onClickHandler: PropTypes.func.isRequired,
  }

  onClickHandler = () => {
    this.props.onClickHandler()
  }

  render() {
    const { type, title, className } = this.props

    return (
      <button type={type} className={className} onClick={this.onClickHandler}>
        {title}
      </button>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js